import { render, staticRenderFns } from "./CelebrityPaymentHistoryTable.vue?vue&type=template&id=7c5d2888&"
import script from "./CelebrityPaymentHistoryTable.vue?vue&type=script&lang=js&"
export * from "./CelebrityPaymentHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
